import { ENVIRONMENT } from '@environments/environment.model';

export type AppEnvironmentName = ENVIRONMENT['envName'];

export const APP_NAME = 'Kore Delivery';

export const PRODUCTION_ENV_NAME: AppEnvironmentName = 'production';

export const APP_ENVIRONMENT_LABEL: Record<AppEnvironmentName, string> = {
  local: 'Local',
  develop: 'Desarrollo',
  qa: 'QA',
  production: 'Producción',
};

export function buildVersionLabel(version: string, envName: AppEnvironmentName): string {
  if (!version) return '';
  if (envName === PRODUCTION_ENV_NAME) return version;
  return `${version} · ${APP_ENVIRONMENT_LABEL[envName]}`;
}
